import React from 'react'
import {ChevronLeftIcon} from "@heroicons/react/24/solid";
import {Link} from "react-router-dom";

const GoToLink = ({url, label, showLeftArrow = false, cssClass = 'button-gray'}) => {
    return (
        <Link to={url}>
            <div className={`${cssClass} flex items-center justify-center`}>
                {showLeftArrow &&
                    <div className="">
                        <ChevronLeftIcon className="h-6 w-6"/>
                    </div>
                }{label}
            </div>
        </Link>
    )
}

export default GoToLink
